import React from "react";

import HeaderSection from "../components/HeaderSection";
import TopMenu from "../components/Navbar/TopMenu";
import Footer from "../components/Footer/Footer";

export default function AboutLayout(props) {
  const { title, subtitle, notFoud, children } = props;
  return (
    <div className="c-main-wrapper">
      <TopMenu background="white" />
      {notFoud !== true && (
        <HeaderSection
          title={title}
          isad={null}
          subtitle={subtitle}
        />
      )}
      {children}
      <Footer />
    </div>
  );
}
